module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/subject-programming-icon-0edefb14ad5550eec044801e69631b4f.svg";